import {
  SPORTSNEW_PLACEMENT_KEY_PREFIX,
  SPORTSNEW_PLACEMENT_UUID_PATTERN,
} from './sportsnewPlacementAttemptIdentity.js';
import { SPORTSNEW_PLACEMENT_ATTEMPT_STATE } from './sportsnewPlacementAttemptPolicy.js';

export const validateSportsnewPlacementAttempt = attempt => (
  attempt
  && [1, 2, 3].includes(attempt.version)
  && typeof attempt.idempotencyKey === 'string'
  && attempt.idempotencyKey.startsWith(SPORTSNEW_PLACEMENT_KEY_PREFIX)
  && SPORTSNEW_PLACEMENT_UUID_PATTERN.test(
    attempt.idempotencyKey.slice(SPORTSNEW_PLACEMENT_KEY_PREFIX.length),
  )
  && /^[0-9a-f]{64}$/i.test(attempt.fingerprint)
  && Object.values(SPORTSNEW_PLACEMENT_ATTEMPT_STATE).includes(attempt.state)
  && Number.isFinite(Number(attempt.userId))
  && Number(attempt.userId) > 0
  && Number.isFinite(Number(attempt.createdAt))
  && Number.isFinite(Number(attempt.updatedAt))
  && Number.isFinite(Number(attempt.expiresAt))
  && (
    attempt.version === 1
    || (
      ['INITIAL', 'RESOLUTION', 'RECOVER'].includes(attempt.phase)
      && SPORTSNEW_PLACEMENT_UUID_PATTERN.test(attempt.challenge)
      && attempt.surface === 'SPORTSNEW_BET_CART'
    )
  )
  && (
    attempt.version < 3
    || (
      Number.isSafeInteger(Number(attempt.accountGeneration))
      && Number(attempt.accountGeneration) > 0
      && (
        attempt.commandFingerprint == null
        || /^[0-9a-f]{64}$/i.test(attempt.commandFingerprint)
      )
      && (attempt.placementReceipt == null || typeof attempt.placementReceipt === 'string')
      && (attempt.receiptExpiresAtMs == null || Number.isFinite(Number(attempt.receiptExpiresAtMs)))
      && (
        attempt.placementReceipt == null
        || (
          /^[0-9a-f]{64}$/i.test(attempt.commandFingerprint)
          && Number.isFinite(Number(attempt.receiptExpiresAtMs))
        )
      )
    )
  )
  ? attempt
  : null
);

export const sportsnewPlacementPersistenceError = () => {
  const error = new Error('Sportsnew placement attempt could not be persisted');
  error.code = 'SPORTSNEW_PLACEMENT_ATTEMPT_PERSISTENCE_UNAVAILABLE';
  return error;
};

export const sportsnewPlacementUnresolvedError = () => {
  const error = new Error('A previous Sportsnew placement attempt is unresolved');
  error.code = 'SPORTSNEW_PLACEMENT_ATTEMPT_UNRESOLVED';
  return error;
};
